import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    autoOpen: { Boolean, default: false },
    targetId: String,
    closeFunction: String
  }

  connect() {
    if (this.autoOpenValue) {
      this.open()
    }
  }

  handleClick(event) {
    if (event.target === this.element) {
      this.close()
    }
  }

  close() {
    // FIXME: temporary additional code path to "close" a dialog, in this case using the dialog element's JS API.
    // This should be the preferred way of closing a dialog, as opposed to removing it from the DOM,
    // in case the dialog needs to open again. Once the shared/modal partial is removed, we can start using
    // the dialog element's JS API to close the dialog everywhere instead of removing the element from the DOM.
    if (this.closeFunctionValue === "hide") {
      this.element.close()
    } else {
      this.element.remove()
    }
  }

  open() {
    this.element.showModal()
  }

  openDialog(event) {
    const dialog = document.getElementById(this.targetIdValue);

    if (dialog) {
      dialog.showModal();
    } else {
      console.error(`Dialog with ID ${this.targetIdValue} not found`);
    }
  }
}
